import "./common-style.css";
import React, { useState, Suspense, lazy, useEffect, useContext } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import "react-loading-skeleton/dist/skeleton.css";
import Footer from "./shared/Footer";
import "./App.scss";
import Utils from "./utilities/utils";
import StoreContext from "./store/StoreContext";
import { Col, Row, Spinner } from "react-bootstrap";
import userroutes from "./routes";
import PasswordSetPage from "./layout/PasswordSetPage";
import ForgotPassword from "./layout/Forgotpassword";
import Forgotpasswordpage from "./layout/Login/Forgotpasswordpage";

const Login = lazy(() => import("./layout/Login/Login"));
const SignUp = lazy(() => import("./layout/Login/SignUp"));
// const PasswordSetPage = lazy(() => import("./layout/PasswordSetPage"));

function App() {
  const { dispatch, StateFunction } = useContext(StoreContext);
  const { HandleOnChange } = StateFunction;
  const History = useHistory();
  const Location = useLocation();
  const [Userrouting, setUserrouting] = useState([]);
  const [storage, setStorage] = useState("");

  useEffect(() => {
    const data = Utils.getCookie("Org_details");
    console.log(data, "ddddddd");
    if (data) {
      setStorage(data);
      const orgid = Utils.getCookie("Org_id");
      const orgdetails = Utils.getCookie("Org_details");
      const usertype = Utils.getCookie("TypeOfUser");
      const userrole = Utils.getCookie("Role");
      // console.log(orgid, orgdetails, usertype, userrole, "uuuuuuuuuuuuuu")
      localStorage.setItem("Org_id", orgid);
      localStorage.setItem("Org_details", orgdetails);
      localStorage.setItem("TypeOfUser", usertype);
      localStorage.setItem("Role", userrole);
    }
  }, []);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("data");
    console.log(encodedData, "encodedData");
    if (encodedData != null) {
      const decodedData = decodeURIComponent(encodedData);
      const data = JSON.parse(decodedData);
      console.log(data); // { foo: 'bar', baz: 123 }
      // const params = new URLSearchParams(window.location.search);
      // const username = params.get('username');
      // const key = params.get('key');
      // const agileProjId = params.get('agileProjId')
      localStorage.setItem("data", data);
      localStorage.setItem("username", data?.username);
      localStorage.setItem("key", data?.key);
    }
    if (localStorage.getItem("Org_id") && Utils.getCookie("token_org")) {
      HandleOnChange(dispatch, {
        target: { name: "Token", value: Utils.getCookie("token_org") },
      });
      setisFullPageLayout(true);
      HandleOnChange(dispatch, {
        target: {
          name: "LoginId",
          value: JSON.parse(localStorage.getItem("Org_id")),
        },
      });
      if (JSON.parse(localStorage.getItem("TypeOfUser")) == "SuperAdmin") {
        let temp = userroutes.filter((e) => e.level == 3);
        setUserrouting(temp);
        let routeLocation = temp.find((e) => e.path === Location.pathname);
        if (routeLocation) {
          History.push(Location.pathname);
        } else {
          History.push("/EnquireDetails");
        }
      } else {
        let temp = userroutes.filter((e) => e.level == 1);

        setUserrouting(temp);
        History.push("/dashboard");
      }
    } else {
      // Location.pathname=="/forgotpasswordpage"||
      if (
        Location.pathname === "/login" ||
        Location.pathname === "/signup" ||
        Location.pathname.includes("/setpassword") ||
        Location.pathname.includes("/forgotpassword")
      ) {
        History.push(Location.pathname);
      } else {
        History.push("/login");
      }
    }
  }, [storage]);

  const [isFullPageLayout, setisFullPageLayout] = useState(false);
  let navbarComponent = <Navbar setisFullPageLayout={setisFullPageLayout} />;
  let sidebarComponent = <Sidebar Userrouting={Userrouting} />;
  let footerComponent = <Footer />;
  return (
    <div className="container-scroller skeleton">
      {isFullPageLayout ? navbarComponent : ""}
      <div
        className={
          isFullPageLayout
            ? "container-fluid page-body-wrapper"
            : "container-fluid page-body-wrapper full-page-wrapper"
        }
      >
        {isFullPageLayout ? sidebarComponent : ""}
        <div className="main-panel">
          <div className="content-wrapper">
            <Suspense
              fallback={
                <Row className="justify-content-center h-100">
                  <Col>
                    <Spinner animation="grow" variant="primary" />
                  </Col>
                </Row>
              }
            >
              <Switch>
                <Route
                  path={"/login"}
                  render={() => (
                    <Login
                      setisFullPageLayout={setisFullPageLayout}
                      setUserrouting={setUserrouting}
                    />
                  )}
                />
                <Route path="/signup" render={() => <SignUp />} />

                <Route
                  component={ForgotPassword}
                  path="/forgotpassword/:token/:email"
                />
                {/* <Route
                  component={Forgotpasswordpage}
                  path="/forgotpasswordpage/"
                /> */}
                <Route
                  component={PasswordSetPage}
                  path="/setpassword/:email/:firstname/:lastname"
                />
                {Userrouting.map((e, key) => (
                  <Route
                    exact
                    path={e.path}
                    key={key}
                    render={() => <e.component />}
                  />
                ))}
                {Userrouting.map((e, key) =>
                  e.MasterTab ? (
                    <Route
                      exact
                      path={e.MasterTab.path}
                      key={key + "." + key}
                      render={() => <e.MasterTab.component />}
                    />
                  ) : null
                )}
              </Switch>
            </Suspense>
          </div>

          {isFullPageLayout ? footerComponent : ""}
        </div>
      </div>
    </div>
  );
}

export default App;
